import React, {useEffect, useState} from "react";

import ParametersDistributionBox from "../../components/partials/ParametersDistributionBox";
import WSTable from "../../components/partials/WSTable";
import "../../styles/workshop_infos.css";

const Sectors = (props) => {

    const {page, computedDatas, results, sector, setSector} = props;

    const [sectorTable, setSectorTable] = useState(null);

    // GET SECTOR TABLE (PARAMETERS)
    useEffect(() => {
        if (computedDatas) {
        const tableTemp = {
            titles: [
            "Paramètre",
            "Valeur médiane",
            "Valeur moyenne",
            "Ecart type",
            "Ecart type relatif",
            "Nb modifications",
            "Nb résultats",
            "% modifications",
            ],
            data: [],
        };
        computedDatas.parameters.map((param) => {
            if (param.category === sector) {
            tableTemp.data.push([
                param.name,
                param.median + " " + param.unit,
                param.average + " " + param.unit,
                param.stdDev,
                param.stdevRel,
                param.nbModif,
                param.nbResults,
                `${((param.nbModif / param.nbResults) * 100).toFixed(2)} %`,
            ]);
            }
        });
        setSectorTable({ ...tableTemp });
        }
    }, [computedDatas, sector]);

    
    const handleSectorsDetailTable = (table, sector) => {
  
        const titlesFinal = [];
        table.titles.map((v,i)=>{
          if (i>0) {titlesFinal.push(v)}
        })
      
    
        let sectorData = [...table.data.filter((line) => line[0] === sector)];
        if (sectorData.length === 0) {
          return null;
        }
    
        let dataFinal=[];
        sectorData.map((line) => {
          let data=[];
          line.map((v,i)=>{
            if (i>0) {data.push(v)}
          })
          dataFinal.push(data)
        });
    
        return { titles: titlesFinal, data: dataFinal };
    };
    return (
        <>
            {computedDatas && (
                <div className="main_container sector-page">
                {page === "Secteurs" && (
                    <div className="sectors-menu flex-item acenter jcenter">
                    {computedDatas.uniqueCategories.map((cat, i) => (
                        <button
                        className={sector === cat ? "btn tab-btn active-bis" : "btn tab-btn"}
                        type="button"
                        id={i}
                        onClick={() => setSector(cat)}
                        >
                        {cat}
                        </button>
                    ))}
                    </div>
                )}

                <h2 className="container_title">Détails par secteur</h2>

                <h3 className="container_secondary_title">Secteurs - Résumé</h3>

                {results && (
                    <WSTable
                    table={handleSectorsDetailTable(
                        { ...results.aggregator.sectorsDetailTable },
                        sector,
                    )}
                    numberDisplayed="all"
                    />
                )}

                <h3 className="container_secondary_title">Paramètres - Résumé</h3>

                {sectorTable && <WSTable table={sectorTable} numberDisplayed="all" />}

                <h3 className="container_secondary_title">Paramètres - Distribution</h3>

                <div id="parameters_distribution_container" className="flex-item jbetween">
                    {computedDatas.parameters
                    .filter((param) => param.category === sector)
                    .map((param, i) => (
                        <ParametersDistributionBox key={i} data={param} />
                    ))}
                </div>
                </div>
            )}
        </>
    )
}

export default Sectors